export default __webpack_public_path__ + "static/media/436.8a91ffc0.gif";